var React = require('react');

function IconRight1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.9973 11.9362C16.9847 11.7337 16.9047 11.5413 16.7702 11.3895L8.59214 2.30381C8.43051 2.12319 8.20344 2.01433 7.96146 2.00134C7.71934 1.98819 7.48198 2.07217 7.30179 2.23441C7.12162 2.3965 7.01355 2.62386 7.00119 2.86595C6.98883 3.10805 7.07344 3.34506 7.23618 3.52474L14.8674 12L7.23618 20.4753C7.07345 20.6549 6.98883 20.8919 7.00119 21.1341C7.01355 21.3762 7.12162 21.6035 7.30179 21.7656C7.48196 21.9278 7.71933 22.0118 7.96147 21.9987C8.20343 21.9857 8.43049 21.8768 8.59214 21.6962L16.7702 12.6105C16.9344 12.4259 17.0164 12.1824 16.9973 11.9362Z","fill":"black"}));
}

IconRight1.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconRight1;

IconRight1.default = IconRight1;
